import React from "react";

interface ProgressStepperProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressStepper: React.FC<ProgressStepperProps> = ({ currentStep, totalSteps }) => {
  const progressPercent = Math.min((currentStep / totalSteps) * 100, 100);

  return (
    <div className="bg-white px-6 pt-4 pb-6 rounded-full mt-10 mb-8">
      <div className="flex justify-between items-center mb-3 text-sm font-medium text-gray-700">
        <span>{`Question ${currentStep} of ${totalSteps}`}</span>
        <span>{`${Math.round(progressPercent)}%`}</span>
      </div>

      <div className="flex h-2 overflow-hidden bg-gray-100 rounded-full">
        <div
          className="bg-[var(--color-gray-900)] transition-all duration-500 ease-in-out rounded-full"
          role="progressbar"
          style={{ width: `${progressPercent}%` }}
          aria-valuenow={progressPercent}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>
    </div>
  );
};

export default ProgressStepper;








// import React from 'react';

// interface ProgressStepperProps {
//   currentStep: number;
//   totalSteps: number;
// }
// const ProgressStepper: React.FC<ProgressStepperProps> = ({ currentStep, totalSteps }) => {
//   const progressPercent = Math.min((currentStep / totalSteps) * 100, 100);

//   return (
//     <div className="bg-white p-5 rounded-full mt-10 mb-20">
//       <div className="flex h-1 overflow-hidden text-xs bg-gray-100 rounded">
//         <div
//           className="flex flex-col justify-center overflow-hidden text-center whitespace-nowrap bg-[var(--color-gray-900)] transition-all duration-500 ease-in-out"
//           role="progressbar"
//           style={{ width: `${progressPercent}%` }}
//           aria-valuenow={progressPercent}
//           aria-valuemin={0}
//           aria-valuemax={100}
//         />
//       </div>
//     </div>
//   );
// };

// export default ProgressStepper;